export default __webpack_public_path__ + "static/media/W_icon_reward_banner.3c371ac8.png";